import React, { useState, useEffect } from "react";
import {
  Button,
  Box,
  Grid,
  Menu,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  PaginationItem,
  Alert,
  Snackbar,
  DialogTitle,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AddConsumptionByFacility from "./AddConsumptionByFacility";
import ViewConsumptionByFacility from "./ViewConsumptionByFacility";
import FilterDrawer from "../../../../Components/Masters/FilterDrawer";
import { get, api, del } from "../../../../utils/api";
import DateRangePickerComponent from "../../../Masters/Roles and Permissions/Filters/Date";
import MultiSelect from "../../../Masters/Roles and Permissions/Filters/MultiSelect";
import Range from "../../../Masters/Roles and Permissions/Filters/Range";
import { styled } from "@mui/material/styles";
import ViewTable from "../../../../Components/Common/ViewTable";
import dayjs from "dayjs";
import PaginationBox from "../../../../Components/Masters/Pagination";
import Cards from "../../../../Components/Common/Cards";
import MonthYearFilter from "../../../Masters/Roles and Permissions/Filters/MonthYearFilter";
import TopMenuUpload from "../../../../Components/Masters/TopMenuUpload";
import BulkUploadModal from "../../../../Components/Common/BulkUploadModal";
import { formatNumber } from "../../../../utils/formatNumber";
import { formatNumberCommaSeparated } from "../../../../utils/common";
import BulkUpload from "../../BulkUpload";
import { useUser } from "../../../../context/AuthContext";
import DeleteAlertDialog from "../../../../Components/Masters/DeleteAlertDialog";
import {
  mapTableDataWithFacility,
  shouldShowFacilityColumn,
  withFacilityViewTableHeader,
} from "../../../../utils/facilityColumn";

const SteamConsumption = () => {
  const { user } = useUser();
  const showFacilityColumn = shouldShowFacilityColumn(user);
  const [petroleums, setPetroleums] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [uniqueValues, setUniqueValues] = useState({});
  const [selectedFields, setSelectedFields] = useState({
    equipment: [],
  });
  const [appliedFilters, setAppliedFilters] = useState({
    date: false,
    "Consumption Month": false,
    previousReading: false,
    currentReading: false,
    unitOfConsumption: false,
    equipment: false,
    "Units Consumed (KWH)": false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [view, setView] = useState(false);
  const [dataView, setdataView] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [previousMeterReading, setPreviousMeterReading] = useState({
    min: "",
    max: "",
  });
  const [currentMeterReading, setCurrentMeterReading] = useState({
    min: "",
    max: "",
  });
  const [unitOfConsumption, setUnitOfConsumption] = useState({
    min: "",
    max: "",
  });
  const [isShortContent, setIsShortContent] = useState(false);

  const [errors, setErrors] = useState({
    Date: false,
    "Previous Reading": false,
    "Current Reading": false,
    "Industrial Equipment": false,
    "Units Consumed(KWH)": false,
    Equipment: false,
  });
  const [dataforView, setdataForView] = useState(null);
  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    startMonth: null,
    endMonth: null,
    equipment: [],
    unitOfConsumption: { min: "", max: "" },
    currentMeterReading: { min: "", max: "" },
    previousMeterReading: { min: "", max: "" },
  });

  const [cardData, setCardData] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [startMonth, setStartMonth] = useState(null);
  const [endMonth, setEndMonth] = useState(null);

  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [excelData, setExcelData] = useState(null);
  const [equipmentData, setEquipmentData] = useState([]);
  const [vendorData, setVendorData] = useState([]);
  const [bulkUploadTable, setBulkUploadTable] = useState(true);
  const [formDataBulkUpload, setFormDataBulkUpload] = useState({});
  const [formData, setFormData] = useState({});
  const [matchData, setMatchData] = useState([]);

  const fetchExcelData = async () => {
    await get("/scope2/steamFacility/steam/equipment")
      .then((res) => {
        let data = res.data;
        let arr = [];
        data.vendorData.forEach((v, vIdx) => {
          data.equipmentData.forEach((e, eIdx) => {
            arr.push({
              "Month (in 01/25 or Jan-25)": "",
              "Vendor Name": v.VendorLegalFullName,
              Equipment: e.equipment,
              "Previous Meter Reading": "",
              "Current Meter Reading": "",
              "Multiplication Factor": "",
              "Remark (optional)": "",
            });
          });
        });
        setExcelData(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    console.log("111");
    fetchExcelData();
  }, []);

  const quarterMonths = {
    1: "Jan-Mar",
    2: "Apr-Jun",
    3: "Jul-Sep",
    4: "Oct-Dec",
  };

  const fetchCardData = async (year, month) => {
    try {
      const response = await get(`${api}/scope2/steamFacility/cardData`, {
        params: { year, month },
      });
      setCardData(response.data.data);
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };

  useEffect(() => {
    console.log("2222");
    fetchCardData(selectedYear, selectedMonth);
  }, [selectedMonth, selectedYear]);

  const formatQuarterPeriod = (year, quarter) => {
    const months = quarterMonths[quarter] || "N/A";
    return `${months}' ${year}`;
  };

  const equipmentList = async () => {
    const response = await get(`/master/Steam/Equipement`);
    setEquipmentData(response.data.data.map((item) => item.equipment));
    return response.data.data.map((item) => item.equipment);
  };
  const vendorList = async () => {
    const response = await get(`/master/Steam/getVendor`);
    setVendorData(response.data.data.map((item) => item.VendorLegalFullName));
    return response.data.data.map((item) => item.VendorLegalFullName);
  };
  useEffect(() => {
    console.log("33333");
    const fetchInitialData = async () => {
      try {
        const [equipment, vendors] = await Promise.all([
          equipmentList(),
          vendorList(),
        ]);

        // Optionally store them in state

        // Now fetch your excel data
        fetchExcelData();
      } catch (error) {
        console.error("Error fetching equipment or vendors:", error);
      }
    };

    fetchInitialData();
  }, []);

  const headers = withFacilityViewTableHeader(
    [
      { key: "createdAt", label: "Date", sortable: true, width: "12%" },
      {
        key: "consumptionPeriod",
        label: "Consumption Month",
        sortable: true,
        width: showFacilityColumn ? "13%" : "15%",
      },
      {
        key: "previousMeterReading",
        label: "Previous meter reading",
        sortable: true,
        truncate: true,
        width: "13%",
      },
      {
        key: "currentMeterReading",
        label: "Current meter reading",
        sortable: true,
        truncate: true,
        width: "13%",
      },
      {
        key: "unitOfConsumption",
        label: "Units Consumed (KWH)",
        sortable: true,
        truncate: true,
        width: "14%",
      },
      {
        key: "vendor",
        label: "Vendor Name",
        sortable: true,
        width: "23%",
      },
    ],
    showFacilityColumn,
    { width: "16%" }
  );

  const inputData = [
    {
      fieldName: "consumptionPeriod",
      title: "Consumption Period",
      required: true,
      type: "date",
    },
    {
      fieldName: "vendor",
      title: "Vendor Name",
      placeholder: "Tap to select",
      type: "select",
      url: `${api}/master/Steam/getVendor?page=1&limit=100`,
      required: true,
      field: "VendorLegalFullName",
    },
    {
      fieldName: "previousMeterReading",
      title: "Previous Meter Reading",
      placeholder: "Enter Previous Meter Reading",
      type: "number",
      required: true,
    },
    {
      fieldName: "currentMeterReading",
      title: "Current Meter Reading",
      placeholder: "Enter Current Meter Reading",
      type: "number",
      required: true,
    },
    {
      fieldName: "multiplicationFactor",
      title: "Multiplication Factor",
      placeholder: "Multiplication Factor",
      type: "number",
      required: true,
    },
    {
      fieldName: "unitOfConsumption",
      title: "Units Consumed",
      placeholder: "Autofilled",
      type: "number",
      adornmentText: "KWH",
      required: true,
    },

    {
      fieldName: "equipment",
      title: "Equipment (optional)",
      placeholder: "Select equipment",
      type: "multiselect",
      url: `${api}/master/Steam/Equipement`,
      field: "equipment",
      required: false,
    },

    {
      fieldName: "reasonForDeviation",
      title: "Reason For Deviation (optional)",
      placeholder: "Enter Reason",
      type: "text",
    },

    {
      fieldName: "remarks",
      title: "Remark (optional)",
      placeholder: "Additional remarks",
      type: "text",
    },
    {
      fieldName: "editRemarkReason",
      title: "Edit Remark Reason",
      placeholder: "Additional edit remarks",
      type: "text",
      condition: true,
    },
    {
      fieldName: "documents",
      title: "Upload Documents (optional)",
      type: "file",
    },
  ];

  const filters = [
    "Date",
    "Consumption Month",
    "Previous Reading",
    "Current Reading",
    "Units Consumed (KWH)",
    // "Equipment
  ];

  // Function to render the selected filter component based on user's choice

  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
            errors={errors.Date}
          />
        );
      case "Consumption Month":
        return (
          <MonthYearFilter
            title={"Consumption Month"}
            startMonth={tempFilter?.startMonth}
            endMonth={tempFilter?.endMonth}
            setStartMonth={(date) =>
              setTempFilter((prev) => ({ ...prev, startMonth: date }))
            }
            setEndMonth={(date) =>
              setTempFilter((prev) => ({ ...prev, endMonth: date }))
            }
            setErrors={setErrors}
            errors={errors.Date}
          />
        );
      case "Equipment":
        return (
          <MultiSelect
            title="Equipment"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  equipment: newValue.equipment || newValue,
                };
              });
            }}
            errors={errors["Equipment"]}
            setErrors={setErrors}
            field="equipment"
            data={uniqueValues.equipment}
          />
        );

      case "Units Consumed (KWH)":
        return (
          <Range
            title="Units Consumed (KWH)"
            selectedRange={tempFilter.unitOfConsumption}
            setSelectedRange={(range) =>
              setTempFilter((prev) => ({
                ...prev,
                unitOfConsumption: range,
              }))
            }
            errors={errors["Units Consumed (KWH)"]}
            setErrors={setErrors}
            placeholderMax="Max(Units)"
            placeholderMin="Min(Units)"
          />
        );
      case "Current Reading":
        return (
          <Range
            title="Current Reading"
            selectedRange={tempFilter.currentMeterReading}
            setSelectedRange={(range) =>
              setTempFilter((prev) => ({
                ...prev,
                currentMeterReading: range,
              }))
            }
            errors={errors["Current Reading"]}
            setErrors={setErrors}
            placeholderMax="Max(KWH)"
            placeholderMin="Min(KWH)"
          />
        );

      case "Previous Reading":
        return (
          <Range
            title="Previous Reading"
            selectedRange={tempFilter.previousMeterReading}
            setSelectedRange={(range) =>
              setTempFilter((prev) => ({
                ...prev,
                previousMeterReading: range,
              }))
            }
            errors={errors["Previous Reading"]}
            setErrors={setErrors}
            placeholderMax="Max(kWH)"
            placeholderMin="Min(kWH)"
          />
        );
      default:
        return null;
    }
  };

  const fetchUniqueValues = async () => {
    try {
      const response = await get(`/scope2/steamFacility/getSteamFacility`);
      const data = response.data.data;

      const uniqueEquipmentType = [
        ...new Set(
          data
            .flatMap((el) => el.equipment?.map((equip) => equip.equipment))
            .filter(Boolean) // Flatten the equipment array and filter out undefined values
        ),
      ];

      return {
        equipment: uniqueEquipmentType,

        // unitOfConsumption:uniqueUnit
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  const handleMenuClick = (event, data) => {
    setAnchorEl(event.currentTarget);
    // setSelectedPetroleum(petroleum);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    // setSelectedPetroleum(null);
  };

  const handleEdit = (data) => {
    handleMenuClose();
    setAddData(true);
    setView(false);
    setdataView(data?._id !== undefined ? data : data?.data);
  };

  const handleView = (data) => {
    handleMenuClose();
    setView(true);
    setAddData(false);
    setdataForView(data?.data);
  };

  const handleDelete = (index) => {
    handleMenuClose();
    setDeleteDialog(true);
    setdataView(index.id);
  };

  const handleDeleteAggree = async () => {
    await del(`/scope2/steamFacility/deleteSteamFacility`, {
      params: {
        Id: dataView,
      },
    })
      .then(async (res) => {
        setDeleteDialog(false);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        fetchData();
      })
      .catch((err) => {
        setsnackOpen({
          open: true,
          message: err.response?.data?.message ?? "Network Error",
          severity: "error",
        });
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // fetching petroleum data
  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
      }).toString();
      const response = await get(
        `/scope2/steamFacility/getSteamFacility?${queryParams}`
      );
      let arr = response?.data?.data?.map((item) => {
        return {
          createdAt: new Date(item.createdAt).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          }),
          unitOfConsumption: item?.unitOfConsumption,
          currentMeterReading: item.currentMeterReading,
          previousMeterReading: item.previousMeterReading,
          equipment: item.equipment,
          vendor: item.vendor?.VendorLegalFullName,
          action: "View",
          id: item?._id,
          data: item,
        };
      });
      setTableData(arr);
      setPetroleums(response.data.data); // Update the user list
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      // setPage(response.data.currentPage); // Update the current page
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
      const year = selectedDate.year();
      const month = selectedDate.month() + 1;
      fetchCardData(year, month);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    console.log("444");
    console.log("44444444444", page, rowsPerPage, sortConfig, filtersToApply);
    fetchData(filtersToApply);
    // fetchData()
  }, [page, rowsPerPage, sortConfig]);

  // default filters to apply
  const filtersToApply = {
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
    startMonth: tempFilter?.startMonth
      ? tempFilter?.startMonth.format("YYYY-MM-DD")
      : "",
    endMonth: tempFilter?.endMonth
      ? tempFilter?.endMonth.format("YYYY-MM-DD")
      : "",
    equipment: tempFilter?.equipment.join(","),

    ...(tempFilter.unitOfConsumption.min
      ? { minUnitConsumption: tempFilter.unitOfConsumption.min }
      : {}),
    ...(tempFilter.unitOfConsumption.max
      ? { maxUnitConsumption: tempFilter.unitOfConsumption.max }
      : {}),
    // Current Meter Reading
    ...(tempFilter.currentMeterReading.min
      ? { minCurrentMeterReading: tempFilter.currentMeterReading.min }
      : {}),
    ...(tempFilter.currentMeterReading.max
      ? { maxCurrentMeterReading: tempFilter.currentMeterReading.max }
      : {}),
    // Previous Meter Reading
    ...(tempFilter.previousMeterReading.min
      ? { minPreviousMeterReading: tempFilter.previousMeterReading.min } // Changed to minPrevious
      : {}),
    ...(tempFilter.previousMeterReading.max
      ? { maxPreviousMeterReading: tempFilter.previousMeterReading.max } // Changed to maxPreviousMeterReading
      : {}),
  };

  // function to validate filters
  const validateFilters = () => {
    let isValid = true;
    const newErrors = {
      Date: false,
      "Previous Reading": false,
      "Current Reading": false,
      "Industrial Equipment": false,
      "Units Consumed (KWH)": false,
      Equipment: false,
    };

    if (selectedFilter === "Date") {
      const today = new Date(); // Get the current date

      // Ensure that startDate and endDate are not greater than today's date
      if (startDate && startDate > today) {
        newErrors.Date = "Start date cannot be in the future";
        isValid = false;
      }

      if (endDate && endDate > today) {
        newErrors.Date = "End date cannot be in the future";
        isValid = false;
      }

      // Ensure that the startDate is less than or equal to the endDate
      if (startDate && endDate && startDate > endDate) {
        newErrors.Date = "End date must be greater than Start date";
        isValid = false;
      }
    }

    if (selectedFilter === "Consumption Month") {
      const today = new Date(); // Get the current date

      // Ensure that startMonth and endMonth are not greater than today's date
      if (startMonth && startMonth > today) {
        newErrors.Date = "Start Month cannot be in the future";
        isValid = false;
      }

      if (endMonth && endMonth > today) {
        newErrors.Date = "End Month cannot be in the future";
        isValid = false;
      }

      // Ensure that the startMonth is less than or equal to the endMonth
      if (startMonth && endMonth && startMonth > endMonth) {
        newErrors.Date = "End Month must be greater than Start Month";
        isValid = false;
      }
    }

    const validateRange = (range, fieldName) => {
      const min = parseFloat(range.min);
      const max = parseFloat(range.max);
      let error = "";

      // Check for numeric values
      if (range.min && isNaN(min)) {
        error = "Please enter a valid number";
        isValid = false;
      }
      if (range.max && isNaN(max)) {
        error = "Please enter a valid number";
        isValid = false;
      }

      // Check for negative values
      if (min < 0 || max < 0) {
        error = "Negative values are not allowed";
        isValid = false;
      }

      // Check min <= max
      if (!isNaN(min) && !isNaN(max)) {
        if (min > max) {
          error = "Minimum value cannot exceed maximum";
          isValid = false;
        }
      }

      if (error) {
        newErrors[fieldName] = error;
      }
    };

    // Validate based on selected filter
    switch (selectedFilter) {
      case "Previous Reading":
        validateRange(tempFilter.previousMeterReading, "Previous Reading");
        break;
      case "Current Reading":
        validateRange(tempFilter.currentMeterReading, "Current Reading");
        break;
      case "Units Consumed (KWH)":
        validateRange(tempFilter.unitOfConsumption, "Units Consumed (KWH)");
        break;
      default:
        break;
    }

    setErrors(newErrors);
    return isValid;
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    if (!validateFilters()) return;
    // Reset to first page when applying filters
    setStartDate(tempFilter.startDate);
    setEndDate(tempFilter.endDate);
    setStartMonth(tempFilter.startMonth);
    setEndMonth(tempFilter.endMonth);
    setSelectedFields({
      equipment: tempFilter.equipment,
    });
    setUnitOfConsumption(tempFilter.unitOfConsumption);
    setCurrentMeterReading(tempFilter.currentMeterReading);
    setPreviousMeterReading(tempFilter.previousMeterReading);

    setPage(1);
    fetchData(filtersToApply);
    setDrawerFilterOpen(false);
    handleAppliedFilters();
  };

  const handleResetFilters = async () => {
    setTempFilter({
      startDate: null,
      endDate: null,
      endMonth: null,
      startMonth: null,
      equipment: [],
      unitOfConsumption: { min: "", max: "" },
      previousMeterReading: { min: "", max: "" },
      currentMeterReading: { min: "", max: "" },
    });
    // Reset local state for date selection and selected fields
    setStartDate(null);
    setEndDate(null);
    setStartMonth(null);
    setEndMonth(null);
    setSelectedFields({
      equipment: [],
    });
    setPreviousMeterReading({ min: "", max: "" });
    setCurrentMeterReading({ min: "", max: "" });
    setUnitOfConsumption({ min: "", max: "" });

    // Call fetchData without any filters
    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied = tempFilter?.startDate || tempFilter?.endDate;
    const isConsumptionMonth = tempFilter?.startMonth || tempFilter?.endMonth;
    const isEquipmentTypeApplied = selectedFields.vendor?.length > 0;
    // const isEquipmentApplied = selectedFields.equipment?.length > 0;
    const isEquipmentApplied = tempFilter?.equipment?.length > 0;

    const isUnitRangeApplied =
      tempFilter.unitOfConsumption.min || tempFilter.unitOfConsumption.max;

    const isCurrentReadingRangeApplied =
      tempFilter.currentMeterReading.min || tempFilter.currentMeterReading.max;

    const isUnitOfConsumptionApplied =
      tempFilter.previousMeterReading.min ||
      tempFilter.previousMeterReading.max;

    setIsFiltersApplied(
      isDateApplied ||
        isConsumptionMonth ||
        isEquipmentTypeApplied ||
        isUnitRangeApplied ||
        isEquipmentApplied ||
        isUnitOfConsumptionApplied ||
        isCurrentReadingRangeApplied
    );

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      "Consumption Month": isConsumptionMonth,
      Equipment: isEquipmentApplied,
      unitConsumption: isUnitRangeApplied,
      "Units Consumed (KWH)": isUnitRangeApplied,
      "Previous Reading": isUnitOfConsumptionApplied,
      "Current Reading": isCurrentReadingRangeApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      startMonth: startMonth,
      endMonth: endMonth,
      equipment: selectedFields.equipment,
      unitOfConsumption: {
        min: unitOfConsumption.min,
        max: unitOfConsumption.max,
      },
      previousMeterReading: {
        min: previousMeterReading.min,
        max: previousMeterReading.max,
      },
      currentMeterReading: {
        min: currentMeterReading.min,
        max: currentMeterReading.max,
      },
    });
    setDrawerFilterOpen(false);
  };

  let bannerData = [
    {
      title: "Total Steam Consumed",
      description: cardData?.total?.totalConsumption
        ? `${formatNumberCommaSeparated(
            formatNumber(cardData.total.totalConsumption)
          )} KWH`
        : "N/A",
    },
    {
      title: "Peak Consumption Period",
      description:
        cardData?.peakData?.year && cardData?.peakData?.quarter
          ? `${formatQuarterPeriod(
              cardData.peakData.year,
              cardData.peakData.quarter
            )} : ${
              formatNumberCommaSeparated(
                formatNumber(cardData.peakData.peakConsumption)
              ) || "0"
            } KWH`
          : "N/A",
    },
    {
      title: "Consumption Month",
      description: cardData?.monthly?.totalConsumption
        ? `${formatNumberCommaSeparated(
            formatNumber(cardData?.monthly?.totalConsumption)
          )} KWH`
        : "N/A",
      filter: "date",
      defaultValue: {},
    },
  ];

  const handlePeriodChange = (key, value, filterType) => {
    const [year, month] = value.split("-");
    setSelectedDate((prev) => ({
      ...prev,
      month,
      year,
    }));
    fetchCardData(year, month, "");
  };

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    fetchData();
  };

  const uploadErrorClose = () => {
    setBulkUploadTable(true);
  };

  const handleOpenFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      startMonth: startMonth,
      endMonth: endMonth,
      equipment: selectedFields.equipment,
      unitOfConsumption: tempFilter.unitOfConsumption,
      previousMeterReading: tempFilter.previousMeterReading,
      currentMeterReading: tempFilter.currentMeterReading,
    });
    setDrawerFilterOpen(true);
  };

  return (
    <Box
      sx={{
        backgroundColor: "#ededed",
      }}
    >
      <Snackbar
        open={snackOpen.open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          severity={snackOpen.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message}
        </Alert>
      </Snackbar>

      <AddConsumptionByFacility
        addData={addData}
        setAddData={setAddData}
        SelectedData={dataView}
        id={dataView ? dataView._id : ""}
        fetchData={fetchData}
        inputData={inputData}
        addUrl={`${api}/scope2/steamFacility/addSteamFacility`}
        updateUrl={`${api}/scope2/steamFacility/updateSteamFacility`}
        setsnackOpen={setsnackOpen}
      />
      <ViewConsumptionByFacility
        view={view}
        setView={setView}
        selectedData={dataforView}
        handleEdit={handleEdit}
        companyAdmin={user?.companyAdmin}
      />

      {/* <Cards data={bannerData} title={"Consumption by Facility"} /> */}
      <Grid item xs={6} sx={{ width: "100%" }}></Grid>

      <Cards
        data={bannerData}
        title={"Steam "}
        onFilterChange={handlePeriodChange}
        {...{
          setSelectedMonth,
          setSelectedYear,
          selectedMonth,
          selectedYear,
        }}
      />

      {/* {deleteDialog && (
        <Dialog open={deleteDialog}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Do you really want to delete this entry?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDeleteDialog(false)} color="primary">
              Cancel
            </Button>
            <Button onClick={handleDeleteAggree} color="secondary">
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      )} */}
      {deleteDialog && (
        <DeleteAlertDialog
          {...{
            deleteDialog,
            setDeleteDialog,
            method: "delete",
            id: dataView,
            url: `${api}/scope2/steamFacility/deleteSteamFacility`,
            setsnackOpen,
            fetchData,
            fetchCardData,
          }}
        />
      )}

      <Box>
        {drawerFilterOpen && (
          <FilterDrawer
            {...{
              renderSelectedFilter,
              drawerFilterOpen,
              setDrawerFilterOpen,
              handleApplyFilters,
              handleFilterDrawer,
              setSelectedFilter,
              handleResetFilters,
              selectedFilter,
              filters,
              appliedFilters,
              selectedFields,
              setSelectedFields,
            }}
          />
        )}{" "}
        {/* Top Box for Heading, Filter Button, Add Data Button */}
        <TopMenuUpload
          setData={setdataView}
          setAddData={setAddData}
          {...{
            // heading: "Coal",
            setBulkUploadModal,
            setDrawerFilterOpen: handleOpenFilterDrawer,
            filterApplied: isFiltersApplied,
          }}
        />
      </Box>

      <ViewTable
        headers={headers}
        data={mapTableDataWithFacility(tableData, showFacilityColumn)}
        title={"Consumption by Facility"}
        onSort={handleSort}
        sortConfig={sortConfig}
        onMenuClick={handleMenuClick}
        editIcon={user?.companyAdmin ? "disable" : "enable"}
        page={2}
        count={10}
        onPageChange={() => {
          // console.log("first");
        }}
        onView={handleView}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      {/* {totalPages > 1 && (
        <PaginationBox
          isShortContent={isShortContent}
          {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
        />
      )} */}
      {totalPages > 1 && (
        <PaginationBox
          {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
        />
      )}

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            width: "120px",
            border: "1px solid #ddd",
            marginLeft: "-47px",
          },
        }}
      >
        <MenuItem onClick={handleView} sx={{ fontSize: "14px" }}>
          <AssignmentIcon sx={{ marginRight: "8px", fontSize: "large" }} /> View
          Logs
        </MenuItem>
        <MenuItem onClick={handleEdit} sx={{ fontSize: "14px" }}>
          <EditIcon sx={{ marginRight: "8px", fontSize: "large" }} /> Edit
        </MenuItem>

        <MenuItem onClick={handleDelete} sx={{ fontSize: "14px" }}>
          <DeleteIcon sx={{ marginRight: "8px", fontSize: "large" }} /> Delete
        </MenuItem>
      </Menu>

      {/* {bulkUploadModal && (
        <BulkUploadModal
          onCloseBulkUpload={handleCloseBulkUpload}
          isBulkUploadModal={bulkUploadModal}
          setsnackOpen={setsnackOpen}
          excelData={excelData}
          fileName={"steam facility"}
          url={"/scope2/steamFacility/steam/bulkupload"}
        />
      )} */}

      {bulkUploadModal && (
        <BulkUploadModal
          onCloseBulkUpload={handleCloseBulkUpload}
          isBulkUploadModal={bulkUploadModal}
          setsnackOpen={setsnackOpen}
          excelData={excelData}
          setBulkUploadModal={setBulkUploadModal}
          formDataBulkUpload={formDataBulkUpload}
          setFormDataBulkUpload={setFormDataBulkUpload}
          setBulkUploadTable={setBulkUploadTable}
          setMatchData={setMatchData}
          matchedKey={"statusList"}
          errorClose={uploadErrorClose}
          fileName={"Steam Facility"}
          url={"/scope2/steamFacility/steam/bulkupload"}
        />
      )}
      {bulkUploadTable && (
        <BulkUpload
          matchData={matchData}
          setMatchData={setMatchData}
          onClose={() => setBulkUploadTable(false)}
          bulkUploadTable={bulkUploadTable}
          formData={formDataBulkUpload}
          setFormData={setFormDataBulkUpload}
          setFormDatas={setFormData}
          formDatas={formData}
          title1="Equipment Name"
          keyValue1="equipment"
          title2="Vendor Name"
          keyValue2="vendor"
          vendorURl={`/master/Steam/creatVendor`}
          EquipmentURl={`/master/Steam/creatEquipment`}
          options1={equipmentData}
          setVendorData={setVendorData}
          setEquipmentData={setEquipmentData}
          options2={vendorData}
          matched1={"equipmentMatched"}
          matched2={"vendorMatched"}
          setsnackOpen={setsnackOpen}
          jsonBulkUpload={formDataBulkUpload}
          bulkUploadUrl={"/scope2/steamFacility/steam/jsonUpload"}
          onConfirm={() => {
              setBulkUploadTable(false);
            fetchData();
          }}
        />
      )}
    </Box>
  );
};

export default SteamConsumption;
